<template>
  <tr>
    <td>
      <span class="ml-5">{{ indent + ' ' + plugin.name }}</span>
    </td>
    <td class="plugin-switch-and-price-col">
      <material-product-details-change-plan-plugins-switcher
        :plugin="plugin"
        :checked="checked"
        @plugin-change="onPluginChange"
      />
    </td>
  </tr>
</template>

<script>
import { INDENT } from '@/constants/app'

export default {
  props: {
    plugin: {
      type: Object,
      required: true
    },
    checked: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      indent: INDENT
    }
  },
  methods: {
    onPluginChange (data) {
      this.$emit('plugin-change', data)
    }
  }
}
</script>

<style scoped>
  .plugin-switch-and-price-col {
    width: 40%;
  }
</style>
